import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

import LoadingSpinner from 'components/common/LoadingSpinner'
import { dispatchActions as dispatchTagActions } from 'components/tag/tagHandlerRedux'

class TagHandler extends Component {
	componentDidMount() {
		const { tag } = this.props.match.params;
		this.props.fetchStickerSnapByTag(tag);
	}

	componentWillUnmount() {
		// reset tag handler once proceeding to stickerhandler, otherwise another scan would directly
		// lead to the previous sticker, since stickerSnap!=null
		this.props.resetTagHandler();
	}

	render() {
		const { isLoading, error, stickerSnap } = this.props.tagHandler;
		let { bundleNo = "" } = this.props.match.params;

		if (error) return <Redirect to={'/home'} />;
		if (isLoading) return <LoadingSpinner message={`Sichere Verbindung wird aufgebaut...`}/>;

		/* redirect to StickerHandler, which fetches the sticker details in turn */
		if (!!stickerSnap) {
			const redirectParams = {
				pathname: !!stickerSnap.bundleId ? `/bundles/${stickerSnap.bundleId}` : `${bundleNo && ("/" + bundleNo)}/stickers/${stickerSnap.stickerId}`,
				state: {
					tagId: stickerSnap.tagId
				}
			};
			return <Redirect to={redirectParams}/>;
		}

		return null;
	}
}

const mapStateToProps = (state) => {
	return {
		tagHandler: state.tagHandler
	}
};

export default connect(mapStateToProps, { ...dispatchTagActions })(TagHandler);


// WEBPACK FOOTER //
// ./src/components/tag/TagHandler.jsx